import { render, staticRenderFns } from "./text-field-area-readonly-input.component.vue?vue&type=template&id=0b4508e6&scoped=true&"
import script from "./text-field-area-readonly-input.component.vue?vue&type=script&lang=ts&"
export * from "./text-field-area-readonly-input.component.vue?vue&type=script&lang=ts&"
import style0 from "./text-field-area-readonly-input.component.vue?vue&type=style&index=0&id=0b4508e6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4508e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
